'use strict';
import * as $j_com$002eraquo$002elaminar$002emodifiers$002e$002dModifier$0024$0024anon$00241 from "./com.raquo.laminar.modifiers.-Modifier$$anon$1.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lcom_raquo_laminar_modifiers_Modifier$() {
  this.Rc = null;
  $n_Lcom_raquo_laminar_modifiers_Modifier$ = this;
  this.Rc = new $j_com$002eraquo$002elaminar$002emodifiers$002e$002dModifier$0024$0024anon$00241.$c_Lcom_raquo_laminar_modifiers_Modifier$$anon$1();
}
export { $c_Lcom_raquo_laminar_modifiers_Modifier$ as $c_Lcom_raquo_laminar_modifiers_Modifier$ };
$p = $c_Lcom_raquo_laminar_modifiers_Modifier$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_laminar_modifiers_Modifier$;
/** @constructor */
function $h_Lcom_raquo_laminar_modifiers_Modifier$() {
}
export { $h_Lcom_raquo_laminar_modifiers_Modifier$ as $h_Lcom_raquo_laminar_modifiers_Modifier$ };
$h_Lcom_raquo_laminar_modifiers_Modifier$.prototype = $p;
var $d_Lcom_raquo_laminar_modifiers_Modifier$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_laminar_modifiers_Modifier$, "com.raquo.laminar.modifiers.Modifier$", ({
  iw: 1
}));
export { $d_Lcom_raquo_laminar_modifiers_Modifier$ as $d_Lcom_raquo_laminar_modifiers_Modifier$ };
var $n_Lcom_raquo_laminar_modifiers_Modifier$;
function $m_Lcom_raquo_laminar_modifiers_Modifier$() {
  if ((!$n_Lcom_raquo_laminar_modifiers_Modifier$)) {
    $n_Lcom_raquo_laminar_modifiers_Modifier$ = new $c_Lcom_raquo_laminar_modifiers_Modifier$();
  }
  return $n_Lcom_raquo_laminar_modifiers_Modifier$;
}
export { $m_Lcom_raquo_laminar_modifiers_Modifier$ as $m_Lcom_raquo_laminar_modifiers_Modifier$ };
